import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class Utils {
    log(message: string, params?: unknown): void {
        if (!environment.production) {
            if (params != undefined) {
                console.log(message, params);
            } else {
                console.log(message);
            }
        }
    }
}
